import { render, staticRenderFns } from "./SelectClientDropdown.vue?vue&type=template&id=1abddfaa&"
import script from "./SelectClientDropdown.vue?vue&type=script&lang=js&"
export * from "./SelectClientDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports